var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hic-dialog',{attrs:{"title":"药品汇总","visible":_vm.visible},on:{"open":_vm.open,"close":_vm.close}},[_c('hic-print-simple',{ref:"printer",attrs:{"tmpl-code":"\tYaoPinHuiZongDan","print-data":_vm.printData,"loading":_vm.loading}}),_c('template',{slot:"footer"},[_c('el-button',{attrs:{"type":"info"},on:{"click":_vm.close}},[_vm._v("关 闭")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }